//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { useContext } from "react";

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";
import Context from "context/context";


function loyaltyAffiliationAPI() {
    // const { state, dispatch } = useContext(Context);
    const { handleResponse, handleError } = HandleApiResponse();

    async function getLoyaltyAffiliation(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                },
            };
            let query;
            query = JSON.stringify(values)
            let res = await fetch(
                `${config.host}/cdr-panel/api/loyalty-affiliation?query=${query}`,
                obj
            );

            return handleResponse(res);
        } catch (error) {
            handleError(error)
        }
    }

    async function search(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                },
            };
            let query;
            query = JSON.stringify(values)
            let res = await fetch(
                `${config.host}/cdr-panel/api/loyalty-affiliation/search?query=${query}`,
                obj
            );

            return handleResponse(res);
        } catch (error) {
            handleError(error)
        }
    }

    async function Export(values) {
        try {
          const obj = {
            method: "POST",
            credentials: 'include',
            headers: {
              "Content-Type": "application/json"          
            },
            body: JSON.stringify(values),
          };
          let res = await fetch(`${config.host}/cdr-panel/api/loyalty-affiliation/export`, obj);
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

    return {
        getLoyaltyAffiliation,
        search,
        Export
    }
}

export default loyaltyAffiliationAPI